"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Page = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _clsx2 = _interopRequireDefault(require("clsx"));
var _core = require("@material-ui/core");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
var styles = function styles(theme) {
  return {
    root: {},
    fillViewport: {
      position: "absolute",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      width: "100%",
      height: "100%"
    }
  };
};
/**
 * Simple page wrapper that fills available space
 *
 * ## Classes
 *
 * - root: applies to the root element
 * - fillViewport: applies when the `fillViewport` prop is set
 */

var Page = function Page(_ref) {
  var classes = _ref.classes,
    className = _ref.className,
    fillViewport = _ref.fillViewport,
    props = _objectWithoutProperties(_ref, ["classes", "className", "fillViewport"]);
  return /*#__PURE__*/_react["default"].createElement(_core.Box, _extends({
    className: (0, _clsx2["default"])("HypPage-root", classes.root, _defineProperty({}, classes.fillViewport, fillViewport), className),
    display: "flex",
    flexDirection: "column",
    alignItems: "stretch",
    justifyContent: "stretch",
    bgcolor: "background.default"
  }, props));
};
exports.Page = Page;
Page.defaultProps = {
  classes: {},
  fillViewport: false
};
Page.propTypes = {
  /** object containing class names for elements */
  classes: _propTypes["default"].object,
  /** class name for root element */
  className: _propTypes["default"].string,
  /** True if the page should fill the viewport */
  fillViewport: _propTypes["default"].bool
};
Page.__docgenInfo = {
  "description": "Simple page wrapper that fills available space\n\n## Classes\n\n- root: applies to the root element\n- fillViewport: applies when the `fillViewport` prop is set",
  "methods": [],
  "displayName": "Page",
  "props": {
    "classes": {
      "defaultValue": {
        "value": "{}",
        "computed": false
      },
      "type": {
        "name": "object"
      },
      "required": false,
      "description": "object containing class names for elements"
    },
    "fillViewport": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "True if the page should fill the viewport"
    },
    "className": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "class name for root element"
    }
  }
};
var exportComponent = (0, _core.withStyles)(styles, {
  name: "HypPage"
})(Page); // copy static props for storybook

if (process.env.NODE_ENV !== "production") {
  exportComponent.displayName = Page.displayName;
  exportComponent.propTypes = Page.propTypes;
  exportComponent.defaultProps = Page.defaultProps;
}
var _default = exportComponent;
exports["default"] = _default;